
import { SubmissionHeader } from "@/components/submission/SubmissionHeader";
import { SubmissionForm } from "@/components/submission/SubmissionForm";
import { useSubmissionForm } from "@/hooks/useSubmissionForm";
import { useCustomer } from "@/context/CustomerContext";
import { LoadingPage } from "@/components/placeholder/LoadingPage";

const Submission = () => {
  const { profile, isLoading } = useCustomer();
  const {
    formData,
    uploadedFiles,
    handleInputChange,
    handleSelectChange,
    handleFileUpload,
    handleSubmit
  } = useSubmissionForm();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Only show loading page when status is input_unprocessed
  if (profile?.status === 'input_unprocessed') {
    return (
      <LoadingPage
        title="Submission Complete 🎉"
        description="You have successfully submitted your energy data. Please wait while we process your information. This may take up to 24 hours."
        showProgressBar={false}
      />
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <SubmissionHeader />
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl p-8">
          <SubmissionForm
            formData={formData}
            uploadedFiles={uploadedFiles}
            handleInputChange={handleInputChange}
            handleSelectChange={handleSelectChange}
            handleFileUpload={handleFileUpload}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default Submission;
